import React from 'react';

import { BackArrowIcon, ChevronLeftArrowIcon } from '@nw/shared/ui';

import { MultiStepGoBackButtonProps } from '../../types/MultiStepRegistrationFormTypes';

import { GoBackContainer, GoBackText } from './styledComponents';

export const MultiStepGoBackButton: React.FC<MultiStepGoBackButtonProps> = ({
  prevStepId,
  prevBtnId,
  prevBtnText,
  customClassNames,
  onBack
}) => {
  if (prevStepId && !prevBtnText) {
    return (
      <GoBackContainer
        type={'button'}
        className={customClassNames.multiStepGoBackBtn}
        id={prevBtnId}
        onClick={onBack}
      >
        <BackArrowIcon />
      </GoBackContainer>
    );
  }

  if (prevStepId && prevBtnText) {
    return (
      <GoBackContainer
        type={'button'}
        className={customClassNames.multiStepGoBackBtn}
        id={prevBtnId}
        onClick={onBack}
      >
        <ChevronLeftArrowIcon />
        <GoBackText className="go-back-button-text">{prevBtnText}</GoBackText>
      </GoBackContainer>
    );
  }

  return <></>;
};
